<div #vodContainer class="container">
  <!-- loader -->
  <div class="loader-overlay" *ngIf="isLoading">
    <mat-spinner diameter="60"></mat-spinner>
  </div>

  <!-- player -->
  <ng-container *ngIf="useShakaPlayer; then shakaTemplate; else tizenTemplate"></ng-container>
  <ng-template #shakaTemplate>
    <div #shakaContainer class="shaka-container">
      <video #shakaVideoElement class="player"></video>
    </div>
  </ng-template>
  <ng-template #tizenTemplate>
    <object class="player" type="application/avplayer" aria-label="avplayer"></object>
  </ng-template>

  <!-- subtitles -->
  <div id="vod-subtitle" [innerHTML]="subtitle" [style.opacity]="subtitleVisible ? 1 : 0" *ngIf="subtitleEnabled"></div>
  <ng-container *ngIf="isVODPage && vod">
    <app-vod-tracks-menu
      [vod]="vod"
      [visible]="trackMenuVisible"
      (hide)="hideTrackMenu()"
      (audioTrack)="onAudioTrackChange($event)"
      (subtitleTrack)="onSubtitleTrackChange($event)"></app-vod-tracks-menu>
  </ng-container>

  <!-- overlay -->
  <div id="vod-overlay" *ngIf="vod">
    <div class="overlay-top">
      <div class="overlay-top__left">
        <button #backButton mat-icon-button class="button htv-selectable" (click)="back()">
          <mat-icon>&#xe5c4;</mat-icon>
        </button>
        <div class="name mat-headline-large">
          {{ vodLang?.title }}
        </div>
      </div>
    </div>
    <div class="overlay-bottom">
      <app-vod-progress
        class="progress-bar"
        [vod]="vod"
        (click)="isPlaying ? pause() : play()"
        (doPause)="pause()"
        (doPlay)="play()"
        (seekTo)="seekTo($event)"></app-vod-progress>
      <div class="buttons">
        <button
          mat-icon-button
          class="button htv-selectable"
          *ngIf="playbackSpeedEnabled"
          [matBadge]="speed < 1 ? speed : null"
          matBadgePosition="below after"
          (click)="fastBackward()"
          [class.button--active]="speed < 1">
          <mat-icon>&#xe020;</mat-icon>
        </button>
        <button mat-icon-button class="button htv-selectable" (click)="jumpBackward()">
          <mat-icon>&#xe05a;</mat-icon>
        </button>
        <button mat-icon-button class="button htv-selectable htv-focus" (click)="isPlaying ? pause() : play()">
          <mat-icon *ngIf="!isPlaying">&#xe037;</mat-icon>
          <mat-icon *ngIf="isPlaying">pause</mat-icon>
        </button>
        <button mat-icon-button class="button htv-selectable" (click)="jumpForward()">
          <mat-icon>&#xe057;</mat-icon>
        </button>
        <button
          mat-icon-button
          class="button htv-selectable"
          *ngIf="playbackSpeedEnabled"
          [matBadge]="speed > 1 ? speed : null"
          matBadgePosition="below after"
          (click)="fastForward()"
          [class.button--active]="speed > 1">
          <mat-icon>&#xe01f;</mat-icon>
        </button>
      </div>
      <div class="right-buttons">
        <button mat-icon-button class="button htv-selectable" (click)="toggleTrackMenu()">
          <mat-icon>&#xe048;</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
